import { getPromo } from './getPromo';
import { getPromos } from './getPromos';
import { EPromoType, IPromo } from '../../types/newbuilding/promos';
import { IApplicationState } from '../../types/redux';

export const getPromosForPreview = (state: IApplicationState): IPromo[] => {
  const promos = getPromos(state);
  const mainPromo = getPromo(state);

  const promosToPreview = (promos as IPromo[])
    .filter(promo => promo.uniquePromoId !== mainPromo?.uniquePromoId)
    .filter(promo => {
      if (promo.promoType === EPromoType.Bank) {
        return !!promo.bank && !!promo.bank.secondSquareImageUrl;
      }

      return promo;
    });

  return promosToPreview.slice(0, 2);
};
